import httpService from './httpService'

class ProductsOrServicesService {
  static search(query) {
    return httpService.post('/products-or-services/search', query)
  }
}

export default ProductsOrServicesService 